////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: "Skip to content" link — keyboard/screen-reader bypass of chrome //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

// Off-screen until focused (see .skip-link in styles/typography.css). Pairs with the
// `id="main-content"` target rendered by the layouts this sits inside.
export function SkipLink () {
  return (
    <a href="#main-content" className="skip-link rounded bg-ink px-4 py-2 text-paper">
      Skip to content
    </a>
  );
}
